export const addCookiesToResponse = ({ res, cookies }) => {
  res.setHeader('Set-Cookie', [
    ...new Set([...(res.getHeader('Set-Cookie') || []), ...cookies]),
  ]);
};
